// extracted by mini-css-extract-plugin
export var label = "_ge-2";
export var slideContainer = "_ge-0";
export var slider = "_ge-1";